import { render, staticRenderFns } from "./PurimNewBulkGift.vue?vue&type=template&id=92054fbc&"
import script from "./PurimNewBulkGift.vue?vue&type=script&lang=js&"
export * from "./PurimNewBulkGift.vue?vue&type=script&lang=js&"
import style0 from "./PurimNewBulkGift.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports